module.exports = __webpack_public_path__ + "static/fonts/Inter-Light.6ffbefc6.ttf";